import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { moduleByPath, MODULES } from "@shared/modules.ts";
import { useBrands } from "../../lib/brand.tsx";
import { useAuth } from "../../lib/auth.tsx";
import { api, type UsageSummary } from "../../lib/api.ts";
import { Icon } from "../../lib/icons.tsx";

export function Topbar({ onMenu }: { onMenu: () => void }) {
  const loc = useLocation();
  const { brands, activeBrandId, setActiveBrandId } = useBrands();
  const { user, logout } = useAuth();
  const [usage, setUsage] = useState<UsageSummary | null>(null);

  const mod =
    moduleByPath(loc.pathname) ||
    MODULES.find((m) => m.path !== "/" && loc.pathname.startsWith(m.path));

  useEffect(() => {
    api.get<UsageSummary>("/ai/usage").then(setUsage).catch(() => {});
  }, [loc.pathname]);

  return (
    <header className="topbar">
      <button className="menu-btn" onClick={onMenu} aria-label="เมนู"><Icon name="Menu" size={20} /></button>
      <div className="topbar__title">{mod?.label ?? "MARKETING Hero"}</div>
      <div className="topbar__spacer" />

      {brands.length > 0 && (
        <label className="brand-switch" title="เลือกแบรนด์ (Brand Context)">
          <Icon name="Building2" size={16} />
          <select value={activeBrandId ?? ""} onChange={(e) => setActiveBrandId(e.target.value || null)}>
            {brands.map((b) => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
        </label>
      )}

      <div className="cost-chip" title="ค่าใช้จ่าย AI สะสม (Mock = ฿0)">
        <Icon name="CircleDollarSign" size={15} />
        {usage ? `$${usage.totalCostUsd.toFixed(4)} · ${usage.calls} ครั้ง` : "$0.0000"}
      </div>

      <div className="avatar" title={user?.name} onClick={() => { if (confirm("ออกจากระบบ?")) logout(); }} style={{ cursor: "pointer" }}>
        {user?.name?.[0]?.toUpperCase() ?? "U"}
      </div>
    </header>
  );
}
